/**
 * GraphQL query for fetching IA Corner promos (highlights).
 * Defines the query structure to retrieve highlight/promo data for an IA Corner,
 * including promotional content with images, titles, and descriptions.
 */

import { gql } from '@apollo/client';

/*******************/
/**     QUERY     **/
/*******************/

/**
 * GraphQL query string for fetching IA Corner highlights/promos.
 * Retrieves paginated highlight data for promotional content display.
 *
 * @param query Query params including device, corner identifier, language, carrier and plan
 * @param params Horizontal pagination parameters
 *
 * IACorner highlights query
 */
const highlights = `highlights(
  query: $query,
  params: $horizontalParams,
) {
  results {
    channelName
    description
    eventId
    id
    image
    isCpg
    order
    sections
    title
    type
  } 
  total
  totalPages
}`;

/**
 * GraphQL query string for fetching IA Corner highlights/promos.
 *
 * @param query Query params including device, corner identifier, language, carrier and plan
 * @param horizontalParams Horizontal pagination parameters
 * @returns Section GraphQL query
 */
const query = gql`
  query SectionQuery(
    $query: QuerySection!
    $horizontalParams: QueryParams!
  ) {
    ${highlights}
  }
`;

export default query;
